import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import { toast, ToastContainer } from 'react-toastify';
import jsPDF from 'jspdf';
import 'react-toastify/dist/ReactToastify.css';
import '../RateTable.css';
import apiService from '../../api/apiService';

const InvoicesTable = ({ data, setData }) => {
  const [viewInvoiceData, setViewInvoiceData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(10);

  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(data.length / rowsPerPage);

  const handleViewInvoice = async item => {
    try {
      const detailsRes = await apiService.get(
        `/invoice-details/?invoice=${item.id}`
      );
      setViewInvoiceData({
        ...item,
        details: detailsRes,
      });
    } catch (err) {
      toast.error('Failed to load invoice details');
    }
  };

  const downloadInvoice = item => {
    const doc = new jsPDF();

    doc.setFontSize(16);
    doc.text(`Invoice ID: ${item.id}`, 20, 20);

    doc.setFontSize(12);
    doc.text(`Booking: ${item.booking}`, 20, 30);
    doc.text(`Date: ${new Date(item.created_at).toLocaleDateString()}`, 20, 40);

    let yOffset = 60;

    if (item.details && item.details.length > 0) {
      doc.text('Details:', 20, 50);

      item.details.forEach((detail, idx) => {
        doc.text(
          `${idx + 1}. ${detail.particulars}: ₹${detail.amount}`,
          25,
          yOffset
        );
        yOffset += 10;
      });
    }

    doc.text(`Total Amount: ₹${item.total_amount}`, 20, yOffset + 10);

    doc.save(`Invoice_${item.id}.pdf`);
  };

  return (
    <div className="rate-table-container">
      <table className="rate-table" style={{ minHeight: '300px' }}>
        <thead>
          <tr>
            <th>Invoice ID</th>
            <th>Booking</th>
            <th>Total Amount</th>
            <th>Created At</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(currentRows) && currentRows.length > 0 ? (
            currentRows.map(item =>
              item && item.id ? (
                <tr key={item.id}>
                  <td>{item.id}</td>
                  <td>{item.booking}</td>
                  <td>₹{item.total_amount}</td>
                  <td>
                    {item.created_at
                      ? new Date(item.created_at).toLocaleDateString()
                      : 'N/A'}
                  </td>
                  <td>
                    <button
                      className="invoice-btn"
                      onClick={() => handleViewInvoice(item)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ) : null
            )
          ) : (
            <tr>
              <td colSpan="5">No data available</td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="pagination">
        <button
          onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>
          Page {currentPage} of {totalPages}
        </span>
        <button
          onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

      {/* View Invoice Modal */}
      {viewInvoiceData && (
        <Modal
          title={`Invoice #${viewInvoiceData.id}`}
          open={!!viewInvoiceData}
          onCancel={() => setViewInvoiceData(null)}
          footer={[
            <button
              key="download"
              className="invoice-btn"
              onClick={() => downloadInvoice(viewInvoiceData)}
            >
              Download
            </button>,
            <button key="close" onClick={() => setViewInvoiceData(null)}>
              Close
            </button>,
          ]}
        >
          <div style={{ lineHeight: '1.6' }}>
            <p>
              <strong>Booking ID:</strong> {viewInvoiceData.booking}
            </p>
            <p>
              <strong>Total Amount:</strong> ₹{viewInvoiceData.total_amount}
            </p>
            <p>
              <strong>Date:</strong>{' '}
              {viewInvoiceData.created_at
                ? new Date(viewInvoiceData.created_at).toLocaleDateString()
                : 'N/A'}
            </p>
            <div style={{ marginTop: '10px' }}>
              <strong>Invoice Details:</strong>
              <ul>
                {viewInvoiceData.details &&
                viewInvoiceData.details.length > 0 ? (
                  viewInvoiceData.details.map((detail, index) => (
                    <li key={index}>
                      {detail.particulars}: ₹{detail.amount}
                    </li>
                  ))
                ) : (
                  <p>No invoice details found.</p>
                )}
              </ul>
            </div>
          </div>
        </Modal>
      )}

      <ToastContainer />
    </div>
  );
};

export default InvoicesTable;
